export default __webpack_public_path__ + "static/media/pattern.251b6018.jpg";